import { Box, Grid } from '@mui/material';
import { useField } from 'react-final-form';

import { Typography, KeyboardTimePicker, Checkboxes } from '@occc-app/design-system';
import { sentenceCase } from '@occc-app/lib/strings';

import { pickerSlotConfiguration } from '../retailer-network-location-update-page.utils';

type ScheduleTimePickerProps = {
  day: string;
};

export const ScheduleTimePicker = ({ day }: ScheduleTimePickerProps) => {
  const openedAllDayField = useField(`schedule.${day}.isOpenAllDay`);
  const isOpenedAllDay = !!openedAllDayField.input.value;

  return (
    <Box flexDirection='row' paddingTop={3} paddingLeft={3}>
      <Grid container alignItems='flex-start' spacing={3}>
        <Grid item xs={12} sm={2} alignSelf='center'>
          <Typography variant='body1' component='h3'>
            {sentenceCase(day)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <KeyboardTimePicker
            label='Opens at'
            name={`schedule.${day}.start`}
            disabled={isOpenedAllDay}
            slotProps={pickerSlotConfiguration}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <KeyboardTimePicker
            label='Closes at'
            name={`schedule.${day}.end`}
            disabled={isOpenedAllDay}
            slotProps={pickerSlotConfiguration}
          />
        </Grid>
        <Grid item xs={12} sm={4} alignSelf='center'>
          <Checkboxes
            name={`schedule.${day}.isOpenAllDay`}
            data={{ label: 'Open All Day', value: true }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
